import React from 'react'
import DataListing from './listing'
import { DataListTemplates, DataTypes } from '../../common/constants'


const _props = {
  handleDownload: (selectedRows, setSelectedRows) => { },
  parentId: "",
  rowsData:[]
}

export const VersionListing = (props = _props) => {
  return (
    <div>
      <DataListing
        fromPopup={true}
        rowsData={props.rowsData}
        parentId={props.parentId}
        paginator={false}
        dataType_id={DataTypes.Documents.id}
        templateName={DataListTemplates.versionList}
        handleDownload={props.handleDownload}
      />
    </div>
  );
};